import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { setDataSession, setUserSession } from 'views/Utils/Common';
import { fetchSinToken,fetchConToken } from 'helpers/fetch';
import { Link } from 'react-router-dom';
import SLUGS from 'resources/slugs';

import fondo from 'images/login/fondo_login.jpg';
import logo from 'images/login/logo.svg'

import woocomerce from 'images/login/Woocomerce.svg'
import amazon from 'images/login/Amazon.svg'
import shopify from 'images/login/Shopify.svg'
import mercado_libre from 'images/login/Mercado_libre.svg'

import Swal from 'sweetalert2';

const Login = ({ history, saludo, subtitulo }) => {
    const baseUrl = process.env.REACT_APP_SERVER_URL;

    const [loading, setLoading] = useState(false);
    const username = useFormInput('');
    const password = useFormInput('');

    const [error, setError] = useState(null);

    //const [empresa, setEmpresa] = useState(0);
    //const [sucursal, setSucursal] = useState(0);
    //const [listEmpresas, setListEmpresas] = useState([]);
    //const [listSucursales, setListSucursales] = useState([]);

    const [opcionModal] = useState('opcionLogin');

    /* 
    const handleChangeEmpresa = (event) => {
        setDataSession('empresa', event.target.value);
    };

    const handleChangeSucursal = (event) => {
        //setSucursal(event.target.value);
        var index = event.nativeEvent.target.selectedIndex;
        setDataSession('sucursalNombre', event.nativeEvent.target[index].text);
    };
    */

    const handleLogin = () => {
        setError(null);
        setLoading(true);

        if(username.value.length == 0)
        {
        Swal.fire("","Capture su usuario",'info');
        setLoading(false);
        return;
        }
        if(password.value.length == 0)
        {
        Swal.fire("","Capture su contraseña",'info');
        setLoading(false);
        return;
        }

        fetchSinToken(
            'Login/Login',
            { usuario: username.value, clave: password.value },
            'POST'
        ).then((response) => {

            if (response.codigo === 500 || response.codigo === 401) {
                Swal.fire("",response.mensajes[0],'info');
                setLoading(false);
                return;
            }

            console.log(response);

            if (response.hasOwnProperty('token')) {
                setUserSession(response.token, response.userName);
                setDataSession('empresa', response.empresa_Id);
                setDataSession('sucursal', response.sucursal_Id);
                setDataSession('rol', response.rol.toUpperCase());
                setDataSession('menu', 'Dashboard');
     
                fetchConToken(
                    `usuarios?id=0&empresa_id=${response.empresa_Id}`
                ).then((responseUsuario) => {
                    setDataSession('nombre', responseUsuario?.nombre);
    
                    if(responseUsuario?.imagen_perfil.length > 0)
                    {
                      setDataSession('imagenPerfil', baseUrl+responseUsuario?.imagen_perfil);
                    }
                });
                
                history.push('/facturas');
            }
            else
            {
                Swal.fire("","No se pudo iniciar sesión",'info');
            }

            
            setLoading(false);
        }).catch((error) => {
            console.log(error)
            var errorMgs = (error.message === "Failed to fetch" ? "Error al conectar con el servidor" : 'Ocurrio un error, contactar con soporte');
            Swal.fire("",errorMgs,'info');
            setLoading(false);
        });
    };

    return (
        <>
            <div
                className='col-12 col-sm-12 col-md-12 row login'
                style={{ minHeight: '100vh', marginLeft: '0' }}
            >
                <div
                    className='col-12 col-md-6'
                    style={{
                        backgroundImage: `url("${Math.abs(window.innerWidth - window.innerHeight) < 200
                                ? fondo
                                : fondo
                            }")`,
                        backgroundRepeat: 'no-repeat',
                        display: window.innerWidth < 768 ? 'none' : 'block',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative'
                    }}
                >
                    <div className='text-left' style={{
                        position: 'absolute',
                        top: '75%',
                        left: '50%',
                        height: '30%',
                        width: '80%',
                        margin: '-15% 0 0 -40%'
                    }}
                    >
                        <div style={{ maxWidth: '100%' }}>
                            <h4 className="white"><b>¡Bienvenido a tu sistema de Facturación electrónica!</b></h4>
                        </div>
                        <br></br>
                        <div style={{ maxWidth: '95%' }}>
                            <p className="white">Recuerda que Factuxin te permite almacenar tus documentos de facturación que has generado a lo largo del tiempo, ingresa con tu cuenta, descarga o envía tus facturas digitales</p>
                        </div>
                        <br></br>
                        <div className='col-md-12 row'>

                            <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                                <img src={woocomerce} alt='' />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                                <img src={amazon} alt=''  />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                                <img src={mercado_libre} alt='' />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>
                                <img src={shopify} alt='' />
                            </div>
                        </div>
                        {/*<br></br><br></br>
                        <div className='col-md-12 row'>
                            <div className='col-4 col-sm-4 col-md-4'>
                                <label className="white" style={{ fontSize: '10px'}}>www.factuxin.com</label>
                            </div>
                            <div className='col-4 col-sm-4 col-md-4'>
                                <label className="white" style={{ fontSize: '10px'}}>www.attiSolutions.com</label>
                            </div>
                            <div className='col-4 col-sm-4 col-md-4'>
                                 <label className="white" style={{ fontSize: '10px'}}>Terminos y políticas del servicio</label>
                            </div>
                    </div>*/}
                    </div>


                </div>
                <div
                    className='col-12 col-md-6 zz'
                    style={{
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundAttachment: 'fixed',
                        backgroundImage: window.innerWidth < 768 ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${fondo})` : 'none',
                        backgroundSize: 'cover',

                    }}
                >
                    <form >
                        <div className='card' style={{
                            boxShadow: 'rgb(30 56 136 / 20%) 8px 8px 48px',
                            borderRadius: '8px',
                            margin: '1% 15% 5px'
                        }}>
                            {opcionModal === 'opcionLogin' ? (
                                <div

                                >
                                    <div className='col-md-12 text-center'>
                                        <Link to={SLUGS.home}>
                                            <img src={window.innerWidth < 768 ? logo : logo} className="img-fyt" alt='' />
                                        </Link>
                                        <h2
                                            style={{
                                                color: '#01295F'
                                            }}
                                        >
                                            <b>¡Bienvenido!</b>
                                        </h2>
                                        <p
                                            style={{
                                                color: '#01295F'
                                            }}
                                        >
                                            Inicie sesión para continuar
                                        </p>
                                    </div>

                                    <div className='col-md-12'>
                                        <div className='col-md-11 container'>
                                            <div className='text-start'>
                                                <label className='form-label'>Nombre</label>
                                                <input
                                                    type='text'
                                                    {...username}
                                                    className='form-control'
                                                    autoComplete='new-password'
                                                    placeholder='Correo'
                                                    style={{ background: '#F4F7FF' }}
                                                    required={true}
                                                />
                                               </div>
                                               <div className='text-start'>
                                                <label className='form-label'>Contraseña</label>
                                                <input
                                                    type='password'
                                                    {...password}
                                                    className='form-control'
                                                    autoComplete='new-password'
                                                    placeholder='Clave'
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-11 container text-center' style={{ paddingBottom: '15px' }}>
                                        {error && (
                                            <>
                                                <small style={{ color: 'red' }}>{error}</small>
                                                <br />
                                            </>
                                        )}
                                        <br />
                                        <input
                                            style={{ width: '100%', background: 'linear-gradient(86.42deg, #232ED1 11.64%, #0F5EF6 80.17%)' }}
                                            type='button'
                                            className='btn-carrousel-home-index'
                                            value={loading ? 'Cargando...' : 'Iniciar sesión'}
                                            onClick={handleLogin}
                                            disabled={loading}
                                        />
                                        <br />
                                        <br></br>
                                        <b>
                                        <Link to= {SLUGS.forgotPassword}
                                                className='text-center'
                                                style={{
                                                    float: 'right',
                                                    color: '#16375b'
                                                }}
                                            >
                                                {' '}
                                                ¿Olvidaste tu contraseña?
                                            </Link>
                                        </b>
                                        <br></br>
                                        <b>
                                            <label>¿Aún no tienes una cuenta?
                                            <Link to= {SLUGS.register} 
                                                >
                                                    {' '}
                                                    Registrate aquí
                                                </Link>

                                            </label>

                                        </b>
                                        <br></br>
                                        <div className='col-md-12'>
                                            <Link to={SLUGS.facturacion}>Facturar</Link>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className='text-center'>
                            <label className='text-footer'>© 2022 Factuxin. Powered by <a href="https://atti.com.mx" target="_blank" rel="noopener noreferrer">AttiSolutions</a></label>
                        </div>

                                        <div style={{background: 'rgba(245, 245, 245, 1)'}}>
                                            <div className=' col-12 col-sm-12 col-md-12 row text-center' >
                                                
                                                <div className='col-6 col-sm-6 col-md-6'>
                                                <a href={SLUGS.terminoscondiciones} target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
                                                </div>
                                                <div className='col-6 col-sm-6 col-md-6'>
                                                <a href={SLUGS.avisoprivacidad} target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                                                </div>
                                            </div>
                                        </div>

                    </form>
                </div>
            </div>
        </>
    );
};

const useFormInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
    return {
        value,
        onChange: handleChange
    };
};

Login.propTypes = {
    saludo: PropTypes.string
};

Login.defaultProps = {
    subtitulo: 'Soy subtitulo'
};

export { Login };
